<div class="tw-flex tw-flex-col tw-flex-1">

  <sb-mega-navbar [navPoints]="navpointsService.navMain"
                  class="tw-shrink-0 sm:tw-h-20 tw-h-14">
    <ul navbar-content class="navbar__wrapper__navbar__nav">
      <li class="nav-item ml-4">
        <button *ngIf="!locked" type="button" (click)="toggleLock()"
                class="btn btn-danger btn-circle">
          <sb-icon *ngIf="locked" icon="lockClosed"></sb-icon>
          <sb-icon *ngIf="!locked" icon="lockOpen"></sb-icon>
        </button>
      </li>
      <!-- removed language selection -->
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a ngbDropdownToggle class="nav-link pr-0 h-100">
          <div class="userContainer">
            <div class="userContainer__details d-none d-sm-block">
              <div class="userContainer__details__username">{{ 'lang.admin.administration' | translate }}</div>
              <div class="userContainer__details__companyname"></div>
            </div>
            <div class="userContainer__picBg" style="background-image: url('./assets/img/no-profile-man.png')">
            </div>
          </div>
          <sb-icon class="pl-2" style="font-size: 0.5rem" icon="chevronDown"></sb-icon>
        </a>
        <div ngbDropdownMenu>
          <ul class="dropdown" style="width: 270px;">
            <li class="head d-block d-sm-none">
              <div class="userContainer w-100 justify-content-between">
                <div class="userContainer__details">
                  <div class="userContainer__details__username">{{ 'lang.admin.administration' | translate }}</div>
                  <div class="userContainer__details__companyname"></div>
                </div>
                <div class="userContainer__picBg"
                     style="background-image: url('./assets/img/no-profile-man.png')">
                </div>
              </div>
            </li>
            <li class="separator d-block d-sm-none"></li>
            <li class="item">
              <a class="item-link">
                <form [formGroup]="form">
                  <div class="form-group">
                    <label class="form-label" for="adminKey">{{ 'lang.admin.adminkey' | translate }}</label>
                    <input name="adminKey" [type]="'text'" autocomplete=false id="adminKey"
                           class="form-control" formControlName="adminKey"
                           style="-webkit-text-security: disc; -moz-text-security: disc;">
                    <div *ngIf="adminKey.touched && adminKey.errors?.required"
                         class="alert alert-danger">
                      {{ 'lang.admin.adminkeyRequest' | translate }}
                    </div>
                  </div>
                </form>
              </a>
            </li>
            <li class="separator"></li>
            <li class="item-content justify-content-center">
              <button [disabled]="locked && adminKey.errors?.required" type="button" (click)="toggleLock()"
                      class="btn btn-circle" [ngClass]="locked ? 'btn-primary' : 'btn-danger'">
                <sb-icon *ngIf="locked" icon="lockClosed"></sb-icon>
                <sb-icon *ngIf="!locked" icon="lockOpen"></sb-icon>
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </sb-mega-navbar>
  <div class="sm:tw-mx-5 tw-mx-3.5 tw-shrink-0">
    <sb-scroll-top-button></sb-scroll-top-button>
    <div class="tw-flex tw-flex-wrap tw-items-center tw-py-6">
      <div class="tw-w-1/2">
        <sb-breadcrumb></sb-breadcrumb>
      </div>
      <div class="tw-w-1/2 tw-justify-end tw-flex tw-text-xl">
        <sb-page-action></sb-page-action>
      </div>
    </div>
  </div>

  <!-- main content -->
  <main class="tw-flex-1 tw-min-h-[500px] sm:tw-mx-5 tw-mx-3.5 sm:tw-mb-5 tw-mb-3.5">
    <router-outlet></router-outlet>
  </main>

  <sb-footer>
    <div footer-bottom>
      <svg style="width: 50px; margin-right:1rem " class="adplacer_logo__footer" xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 624 488">
        <g>
          <polygon class="cls-1"
                   points="222.13 383.71 222.13 216.17 142.84 240.88 142.84 463 329.79 463 409.08 383.72 222.13 383.71">
          </polygon>
        </g>
        <g>
          <polygon class="cls-2"
                   points="254.34 117.51 248.67 197.41 409.07 196.81 409.07 383.75 488.35 304.46 488.36 117.51 254.34 117.51">
          </polygon>
        </g>
        <g>
          <path class="cls-3"
                d="M85.46,59.74a129.5,129.5,0,0,0,0,183.11c50.54,50.54,244.15,61,244.15,61s-10.48-193.6-61-244.15A129.48,129.48,0,0,0,85.46,59.74ZM228.08,202.36a72.2,72.2,0,1,1,0-102.16A72.23,72.23,0,0,1,228.08,202.36Z">
          </path>
        </g>
      </svg>
      <a class="cursor-pointer" (click)="showBackendChangelog()">
        {{ getBackendName() }} {{ getBackendVersion() ? getBackendVersion() : '???' }}
      </a>
      ||
      <a class="cursor-pointer" (click)="showFrontendChangelog()">
        {{ getFrontendName() }} {{ getFrontendVersion() ? getFrontendVersion() : '???' }}
      </a>
    </div>
  </sb-footer>
</div>
